import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectKeyTerms } from "../../store/selectors";
import ModuleHeader from "../modules/ModuleHeader";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import { useTranslation } from "react-i18next";
import Card from "../common/Card";
import BurgerIcon from "../common/BurgerIcon";

const KeyTermsPage = () => {
  useClearCurrentTopic();
  const terms = useSelector(selectKeyTerms);
  const { t } = useTranslation();
  return (
    <>
      <ModuleHeader title={t("keyTerms")} />
      <Card>
        <div className="flex flex-wrap">
          {terms.map((term) => (
            <div
              className="mr-4 mt-3 border hover:bg-gray-700 hover:text-white py-3 px-8 transition-all"
              key={term.id}
            >
              <Link
                className="block hover:text-white text-center"
                to={`/app/key-terms/${term.contentKey}`}
              >
                <span>{term.data.title || term.title}</span>
              </Link>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
};

export default KeyTermsPage;
